module.exports = __webpack_public_path__ + "static/boardmember2-ad30d56d1ded852bb47884d95536c690.jpg";